import { apiClient } from './ApiService';
import { ErrorResponse, ValidationException, ServerException } from './Exceptions';

interface CampaignStreamsResponse {
  status: number;
  message: string;
  data: {
    janus_room_id: number;
    streams: StreamSession[];
  };
}

export interface Room {
  room: number;
  description?: string;
}

export interface StartStreamResponse {
  task_id: string;
  message: string;
}

export interface StopStreamResponse {
  status: string;
  session_id: string;
}

export interface ActiveStream {
  id: string;
  drone_id: string | null;
  drone_name: string;
  room_id: number;
  status: string;
  created_at: string | null;
}

export interface StreamSession {
  id: number;
  task_id: string;
  room_id: number;
  stream_url: string;
  display_name: string;
  campaign: number | null;
  drone_profile: number | null;
  janus_session_id: string | null;
  janus_handle_id: string | null;
  ant_media_stream_id: string;
  status:
    | 'STARTING'
    | 'CONNECTED'
    | 'STREAMING'
    | 'RECONNECTING'
    | 'RECONNECT_FAILED'
    | 'FAILED'
    | 'STOPPED'
    | 'COMPLETED'
    | 'COMPLETED_WITH_ERRORS';
  health_check_time: string;
  created_at: string;
  is_test: boolean;
  janus_heartbeat: string | null;
  error_message: string | null;
  retry_count: number;
  stream_type: 'VIDEO' | 'AUDIO' | 'DATA';
  video_metadata: Record<string, any>;
  metadata: Record<string, any>;
}

export interface CreateRoomAndStreamRequest {
  description: string;
  rtsp_url: string | null;
  display_name: string;
}

export class VideoStreamService {
  static async getCampaignStreams(campaignId: number | string): Promise<{
    janus_room_id: number;
    streams: StreamSession[];
  }> {
    const response = await apiClient.get<CampaignStreamsResponse>(`/videostreamhub/campaign/${campaignId}/streams/`);
    return response.data;
  }
}
